import { render } from "./VoteBanner.vue?vue&type=template&id=7f51635a&ts=true"
import script from "./VoteBanner.vue?vue&type=script&lang=ts"
export * from "./VoteBanner.vue?vue&type=script&lang=ts"

import "./VoteBanner.vue?vue&type=style&index=0&id=7f51635a&lang=scss"

import exportComponent from "/home/node/app/.yarn/__virtual__/vue-loader-virtual-2429a647ea/0/cache/vue-loader-npm-17.0.0-6ebaa2d3c5-0c0a647a4e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__